enum Routes {
  MyApplication = '/my-application',
  MyApplications = '/my-applications',
  Projects = '/projects',
  ViewProject = '/view-project',
  AddProject = '/add-project',
  EditProject = '/edit-project',
  AddEducation = '/add-education',
  EditEducation = '/edit-education',
  Profile = '/profile',
  Roles = '/roles',
  GetSetUp = '/get-set-up',
  OpenProjects = '/open-projects',
  PreparingTest = '/preparing-test',
  Settings = '/settings',
  AddRoles = '/add-roles',
  Developers = '/developers',
  TermsOfUse = 'https://lemon.io/terms-of-use/',
  PrivacyPolicy = 'https://lemon.io/privacy-policy/',
  WelcomeQ = '/welcome/q',
  WelcomeD = '/welcome/d',
  EscapeTheMatrix = '/escape-the-matrix',
  Faq = '/faq',
}

export default Routes;
